import axios from "axios"

export async function isFirstDocument(): Promise<boolean> {
  const { data }: Record<"data", boolean> = await axios.get(
    "/DocumentoComercial/any-documento-firmado"
  )
  return data
}
